import { DirectInstrumentDayBarMessage } from '../DirectMessages/DirectInstrumentDayBarMessage';
import { HistoryType } from '../History/HistoryType';
import { DateTimeUtils } from '../Time/DateTimeUtils';
import { StringUtils } from '../StringUtils';
export class InstrumentDayInfo {
    get OpenInterest() {
        return this.openInterest;
    }
    get SettlementPrice() {
        return this.settlementPrice;
    }
    get PrevSettlementPrice() {
        return this.prevSettlementPrice;
    }
    get FiftyTwoWeekHighPrice() {
        return this.fiftyTwoWeekHighPrice;
    }
    set FiftyTwoWeekHighPrice(value) {
        this.fiftyTwoWeekHighPrice = value;
    }
    get strFiftyTwoWeekHighPrice() {
        return this.FormatPrice(this.FiftyTwoWeekHighPrice);
    }
    get FiftyTwoWeekLowPrice() {
        return this.fiftyTwoWeekLowPrice;
    }
    set FiftyTwoWeekLowPrice(value) {
        this.fiftyTwoWeekLowPrice = value;
    }
    get strFiftyTwoWeekLowPrice() {
        return this.FormatPrice(this.FiftyTwoWeekLowPrice);
    }
    get High13Week() {
        return this.high13Week;
    }
    set High13Week(value) {
        this.high13Week = value;
    }
    get Low13Week() {
        return this.low13Week;
    }
    set Low13Week(value) {
        this.low13Week = value;
    }
    get High26Week() {
        return this.high26Week;
    }
    set High26Week(value) {
        this.high26Week = value;
    }
    get Low26Week() {
        return this.low26Week;
    }
    set Low26Week(value) {
        this.low26Week = value;
    }
    get ReferencePrice() {
        return this.referencePrice;
    }
    set ReferencePrice(value) {
        this.referencePrice = value;
    }
    strReferencePrice() {
        return this.FormatPrice(this.ReferencePrice);
    }
    get IsSnapshot() {
        return this.isSnapshot;
    }
    set IsSnapshot(value) {
        this.isSnapshot = value;
    }
    get IsAllowSubscribeL1() {
        return this.isAllowSubscribeL1;
    }
    set IsAllowSubscribeL1(value) {
        this.isAllowSubscribeL1 = value;
    }
    get InstrumentDayBarMessageUpdateMode() {
        return this.instrumentDayBarMessageUpdateMode;
    }
    set InstrumentDayBarMessageUpdateMode(value) {
        this.instrumentDayBarMessageUpdateMode = value;
    }
    constructor(instrument) {
        this.bidOpen = NaN;
        this.askOpen = NaN;
        this.tradeOpen = NaN;
        this.bidHigh = NaN;
        this.askHigh = NaN;
        this.tradeHigh = NaN;
        this.bidLow = NaN;
        this.askLow = NaN;
        this.tradeLow = NaN;
        this.bidPrevClose = NaN;
        this.askPrevClose = NaN;
        this.tradePrevClose = NaN;
        this.bidMainClose = NaN;
        this.askMainClose = NaN;
        this.tradeMainClose = NaN;
        this.lastPrice = NaN;
        this.bidTicks = 0;
        this.askTicks = 0;
        this.tradeTicks = 0;
        this.bidTotalvolume = NaN;
        this.askTotalvolume = NaN;
        this.tradeTotalvolume = NaN;
        this.settlementPrice = NaN;
        this.prevSettlementPrice = NaN;
        this.fiftyTwoWeekHighPrice = NaN;
        this.fiftyTwoWeekLowPrice = NaN;
        this.high13Week = NaN;
        this.low13Week = NaN;
        this.high26Week = NaN;
        this.low26Week = NaN;
        this.referencePrice = NaN;
        this.instrument = instrument;
        this.Localize();
    }
    Localize() {
        this.NAString = StringUtils.NOT_AVAILABLE;
    }
    FormatPrice(price) {
        return !isNaN(price) ? this.instrument.formatPrice(price) : this.NAString;
    }
    NewQuote(mess) {
        switch (mess.Type) {
            case HistoryType.QUOTE_LEVEL1:
                this.NewQuote1Message(mess);
                break;
            case HistoryType.QUOTE_TRADES:
                this.NewQuote3Message(mess);
                break;
            case HistoryType.QUOTE_INSTRUMENT_DAY_BAR:
                this.NewIdbmMessage(mess);
                break;
        }
    }
    NewQuote1Message(q1Mess) {
        this.askVenue = q1Mess.AskVenue;
        this.bidVenue = q1Mess.BidVenue;
        if (this.InstrumentDayBarMessageUpdateMode) {
            return;
        }
        if (isNaN(this.bidOpen)) {
            this.bidOpen = q1Mess.Bid;
        }
        if (isNaN(this.askOpen)) {
            this.askOpen = q1Mess.Ask;
        }
        this.bidHigh = this.UpdateHigh(this.bidHigh, q1Mess.Bid);
        this.bidLow = this.UpdateLow(this.bidLow, q1Mess.Bid);
        this.askHigh = this.UpdateHigh(this.askHigh, q1Mess.Ask);
        this.askLow = this.UpdateLow(this.askLow, q1Mess.Ask);
        if (!isNaN(q1Mess.Ask)) {
            this.askTicks++;
        }
        if (!isNaN(q1Mess.Bid)) {
            this.bidTicks++;
        }
        if (isNaN(this.tradeOpen)) {
            this.tradeOpen = this.bidOpen;
        }
        if (isNaN(this.tradePrevClose)) {
            this.tradePrevClose = this.bidPrevClose;
        }
    }
    NewQuote3Message(q3Mess) {
        if (q3Mess.OpenInterest) {
            this.openInterest = q3Mess.OpenInterest;
        }
        if (this.InstrumentDayBarMessageUpdateMode) {
            return;
        }
        this.tradeVenue = q3Mess.Exchange;
        this.tradeTicks++;
        if (isNaN(this.tradeTotalvolume)) {
            this.tradeTotalvolume = q3Mess.Size;
        }
        else {
            this.tradeTotalvolume += q3Mess.Size;
        }
        this.tradeHigh = this.UpdateHigh(this.tradeHigh, q3Mess.Price);
        this.tradeLow = this.UpdateLow(this.tradeLow, q3Mess.Price);
        if (isNaN(this.tradeOpen)) {
            this.tradeOpen = q3Mess.Price;
        }
    }
    NewIdbmMessage(idbmMess) {
        if (idbmMess.InstrumentBarType === HistoryType.QUOTE_TRADES) {
            if (!isNullOrUndefined(idbmMess.Open)) {
                this.tradeOpen = idbmMess.Open;
            }
            if (!isNullOrUndefined(idbmMess.High)) {
                this.tradeHigh = idbmMess.High;
            }
            if (!isNullOrUndefined(idbmMess.Low)) {
                this.tradeLow = idbmMess.Low;
            }
            if (!isNullOrUndefined(idbmMess.PreviousClosePrice)) {
                this.tradePrevClose = idbmMess.PreviousClosePrice;
            }
            if (!isNullOrUndefined(idbmMess.TodayClosePrice)) {
                this.tradeMainClose = idbmMess.TodayClosePrice;
            }
            else if (!isNullOrUndefined(idbmMess.LastPrice) && !isNaN(this.tradeOpen)) {
                this.tradeMainClose = idbmMess.LastPrice;
            }
            if (!isNullOrUndefined(idbmMess.Ticks)) {
                this.tradeTicks = idbmMess.Ticks;
            }
            if (!isNullOrUndefined(idbmMess.Volume)) {
                this.tradeTotalvolume = idbmMess.Volume;
            }
            if (!isNullOrUndefined(idbmMess.LastPrice) && !isNaN(idbmMess.LastPrice)) {
                this.lastPrice = idbmMess.LastPrice;
            }
            if (!isNullOrUndefined(idbmMess.LastVenue)) {
                this.tradeVenue = idbmMess.LastVenue;
            }
        }
        else if (idbmMess.InstrumentBarType === HistoryType.QUOTE_ASK) {
            if (!isNullOrUndefined(idbmMess.Open)) {
                this.askOpen = idbmMess.Open;
            }
            if (!isNullOrUndefined(idbmMess.High)) {
                this.askHigh = idbmMess.High;
            }
            if (!isNullOrUndefined(idbmMess.Low)) {
                this.askLow = idbmMess.Low;
            }
            if (!isNullOrUndefined(idbmMess.PreviousClosePrice)) {
                this.askPrevClose = idbmMess.PreviousClosePrice;
            }
            if (!isNullOrUndefined(idbmMess.TodayClosePrice)) {
                this.askMainClose = idbmMess.TodayClosePrice;
            }
            if (!isNullOrUndefined(idbmMess.Ticks)) {
                this.askTicks = idbmMess.Ticks;
            }
            if (!isNullOrUndefined(idbmMess.Volume)) {
                this.askTotalvolume = idbmMess.Volume;
            }
        }
        else {
            if (!isNullOrUndefined(idbmMess.Open)) {
                this.bidOpen = idbmMess.Open;
            }
            if (!isNullOrUndefined(idbmMess.High)) {
                this.bidHigh = idbmMess.High;
            }
            if (!isNullOrUndefined(idbmMess.Low)) {
                this.bidLow = idbmMess.Low;
            }
            if (!isNullOrUndefined(idbmMess.PreviousClosePrice)) {
                this.bidPrevClose = idbmMess.PreviousClosePrice;
            }
            if (!isNullOrUndefined(idbmMess.TodayClosePrice)) {
                this.bidMainClose = idbmMess.TodayClosePrice;
            }
            if (!isNullOrUndefined(idbmMess.Ticks)) {
                this.bidTicks = idbmMess.Ticks;
            }
            if (!isNullOrUndefined(idbmMess.Volume)) {
                this.bidTotalvolume = idbmMess.Volume;
            }
        }
        if (idbmMess.InstrumentBarType === this.instrument.HistoryType) {
            if (!isNullOrUndefined(idbmMess.OpenInterest)) {
                this.openInterest = idbmMess.OpenInterest;
            }
            if (!isNullOrUndefined(idbmMess.SettlementPrice)) {
                this.settlementPrice = idbmMess.SettlementPrice;
            }
            if (!isNullOrUndefined(idbmMess.PrevSettlementPrice)) {
                this.prevSettlementPrice = idbmMess.PrevSettlementPrice;
            }
            if (!isNullOrUndefined(idbmMess.FiftyTwoWeekHighPrice)) {
                this.FiftyTwoWeekHighPrice = idbmMess.FiftyTwoWeekHighPrice;
            }
            if (!isNullOrUndefined(idbmMess.FiftyTwoWeekLowPrice)) {
                this.FiftyTwoWeekLowPrice = idbmMess.FiftyTwoWeekLowPrice;
            }
            if (!isNullOrUndefined(idbmMess.High13Week)) {
                this.High13Week = idbmMess.High13Week;
            }
            if (!isNullOrUndefined(idbmMess.Low13Week)) {
                this.Low13Week = idbmMess.Low13Week;
            }
            if (!isNullOrUndefined(idbmMess.High26Week)) {
                this.High26Week = idbmMess.High26Week;
            }
            if (!isNullOrUndefined(idbmMess.Low26Week)) {
                this.Low26Week = idbmMess.Low26Week;
            }
            if (!isNullOrUndefined(idbmMess.ReferencePrice)) {
                this.ReferencePrice = idbmMess.ReferencePrice;
            }
        }
    }
    Ticks() {
        return this.getTicks(this.instrument.HistoryType);
    }
    strTicks() {
        const ticks = this.Ticks();
        return this.FormatPrice(ticks);
    }
    getOpen(account) {
        return this.OpenSpreadStatic(account, this.instrument);
    }
    strOpen(account) {
        return this.FormatPrice(this.getOpen(account));
    }
    getHigh(account) {
        return this.HighSpreadStatic(account, this.instrument);
    }
    strHigh(account) {
        return this.FormatPrice(this.getHigh(account));
    }
    getLow(account) {
        return this.LowSpreadStatic(account, this.instrument);
    }
    strLow(account) {
        return this.FormatPrice(this.getLow(account));
    }
    getPrevClose(account) {
        return this.PrevCloseSpreadStatic(account, this.instrument);
    }
    strPrevClose(account) {
        return this.FormatPrice(this.getPrevClose(account));
    }
    getMainClose(account) {
        return this.MainCloseSpreadStatic(account, this.instrument);
    }
    getClose(account) {
        const last = this.instrument.Level1.GetLastPrice(account);
        return !isNaN(last) ? last : this.getMainClose(account);
    }
    strClose(account) {
        return this.FormatPrice(this.getClose(account));
    }
    TotalVolume() {
        return this.getTotalVolume(this.instrument.HistoryType);
    }
    getTotalVolume(type) {
        switch (type) {
            case HistoryType.QUOTE_LEVEL1:
                return this.bidTotalvolume;
            case HistoryType.QUOTE_ASK:
                return this.askTotalvolume;
            case HistoryType.QUOTE_TRADES:
                return this.tradeTotalvolume;
            default:
                return this.tradeTotalvolume;
        }
    }
    getTicks(type) {
        switch (type) {
            case HistoryType.QUOTE_LEVEL1:
                return this.bidTicks;
            case HistoryType.QUOTE_ASK:
                return this.askTicks;
            case HistoryType.QUOTE_TRADES:
                return this.tradeTicks;
            default:
                return this.tradeTicks;
        }
    }
    OpenSpreadStatic(acc, instr) {
        if (instr === null) {
            return NaN;
        }
        return instr.InstrumentDayInfo.OpenSpread(this.GetSpreadItem(acc, instr), instr.HistoryType);
    }
    OpenSpread(spreadItem, type) {
        return this.GetSpreadValue(this.instrument, spreadItem, type, this.bidOpen, this.askOpen, this.tradeOpen);
    }
    HighSpreadStatic(acc, instr) {
        if (instr === null) {
            return NaN;
        }
        return instr.InstrumentDayInfo.HighSpread(this.GetSpreadItem(acc, instr), instr.HistoryType);
    }
    HighSpread(spreadItem, type) {
        return this.GetSpreadValue(this.instrument, spreadItem, type, this.bidHigh, this.askHigh, this.tradeHigh);
    }
    LowSpreadStatic(acc, instr) {
        if (instr === null) {
            return NaN;
        }
        return instr.InstrumentDayInfo.LowSpread(this.GetSpreadItem(acc, instr), instr.HistoryType);
    }
    LowSpread(spreadItem, type) {
        return this.GetSpreadValue(this.instrument, spreadItem, type, this.bidLow, this.askLow, this.tradeLow);
    }
    PrevCloseSpread(spreadItem, type) {
        return this.GetSpreadValue(this.instrument, spreadItem, type, this.bidPrevClose, this.askPrevClose, this.tradePrevClose);
    }
    PrevCloseSpreadStatic(acc, instr) {
        if (instr === null) {
            return NaN;
        }
        return instr.InstrumentDayInfo.PrevCloseSpread(this.GetSpreadItem(acc, instr), instr.HistoryType);
    }
    MainCloseSpreadStatic(acc, instr) {
        if (instr === null) {
            return NaN;
        }
        return instr.InstrumentDayInfo.MainCloseSpread(this.GetSpreadItem(acc, instr), instr.HistoryType);
    }
    MainCloseSpread(spreadItem, type) {
        return this.GetSpreadValue(this.instrument, spreadItem, type, this.bidMainClose, this.askMainClose, this.tradeMainClose);
    }
    GetSpreadValue(instr, spreadItem, type, bid, ask, trade) {
        if (spreadItem === null) {
            return this.GetNonSpreadValue(type, bid, ask, trade);
        }
        switch (type) {
            case HistoryType.QUOTE_LEVEL1:
                return spreadItem.CalcBid(bid, ask, instr);
            case HistoryType.QUOTE_ASK:
                return spreadItem.CalcAsk(bid, ask, instr);
            case HistoryType.QUOTE_TRADES:
                return trade;
            default:
                return trade;
        }
    }
    GetNonSpreadValue(type, bid, ask, trade) {
        switch (type) {
            case HistoryType.QUOTE_LEVEL1:
                return bid;
            case HistoryType.QUOTE_ASK:
                return ask;
            case HistoryType.QUOTE_TRADES:
                return trade;
            default:
                return trade;
        }
    }
    GetSpreadItem(acc, instr) {
        const spreadPlan = instr.DataCache.GetSpreadPlan(acc);
        if (isNullOrUndefined(spreadPlan)) {
            return null;
        }
        return spreadPlan.IsNotEmptyPlan(instr) ? spreadPlan.GetItem(instr) : null;
    }
    UpdateHigh(high, curPrice) {
        if (!isNaN(curPrice) && (curPrice > high || isNaN(high))) {
            return curPrice;
        }
        return high;
    }
    UpdateLow(low, curPrice) {
        if (!isNaN(curPrice) && (curPrice < low || isNaN(low))) {
            return curPrice;
        }
        return low;
    }
    GetBidVenue() {
        return this.bidVenue ? this.bidVenue : this.NAString;
    }
    GetAskVenue() {
        return this.askVenue ? this.askVenue : this.NAString;
    }
    GetLastVenue() {
        return this.tradeVenue ? this.tradeVenue : this.NAString;
    }
    GeneratedInstrumentDayBarMessages() {
        const now = DateTimeUtils.DateTimeNow();
        const tradableId = this.instrument.InstrumentTradableID;
        const routeId = this.instrument.Route;
        const i_id = this.instrument.GetInteriorID();
        // по трейдам
        const idbmTrade = new DirectInstrumentDayBarMessage();
        idbmTrade.InstrumentBarType = HistoryType.QUOTE_TRADES;
        idbmTrade.TradableId = tradableId;
        idbmTrade.QuoteRouteId = routeId;
        idbmTrade.cTime = now;
        idbmTrade.TargetInstrumentName = i_id;
        if (!isNaN(this.tradeOpen)) {
            idbmTrade.Open = this.tradeOpen;
        }
        if (!isNaN(this.tradeHigh)) {
            idbmTrade.High = this.tradeHigh;
        }
        if (!isNaN(this.tradeLow)) {
            idbmTrade.Low = this.tradeLow;
        }
        if (!isNaN(this.tradePrevClose)) {
            idbmTrade.PreviousClosePrice = this.tradePrevClose;
        }
        if (!isNaN(this.tradeMainClose)) {
            idbmTrade.TodayClosePrice = this.tradeMainClose;
        }
        if (this.tradeTicks !== 0) {
            idbmTrade.Ticks = this.tradeTicks;
        }
        if (!isNaN(this.tradeTotalvolume)) {
            idbmTrade.Volume = this.tradeTotalvolume;
        }
        idbmTrade.LastTime = this.instrument.Level1.getLastMessageTime;
        const last = this.instrument.Level1.GetLastPrice(null);
        if (!isNaN(this.lastPrice) && !isNaN(last)) {
            idbmTrade.LastPrice = last;
        }
        const lastSize = this.instrument.Level1.GetLastSize(false);
        if (!isNaN(lastSize)) {
            idbmTrade.LastSize = lastSize;
        }
        if (this.tradeVenue) {
            idbmTrade.LastVenue = Number(this.tradeVenue);
        }
        // по аскам
        const idbmAsk = new DirectInstrumentDayBarMessage();
        idbmAsk.InstrumentBarType = HistoryType.QUOTE_ASK;
        idbmAsk.TradableId = tradableId;
        idbmAsk.QuoteRouteId = routeId;
        idbmAsk.cTime = now;
        idbmAsk.TargetInstrumentName = i_id;
        if (!isNaN(this.askOpen)) {
            idbmAsk.Open = this.askOpen;
        }
        if (!isNaN(this.askHigh)) {
            idbmAsk.High = this.askHigh;
        }
        if (!isNaN(this.askLow)) {
            idbmAsk.Low = this.askLow;
        }
        if (!isNaN(this.askPrevClose)) {
            idbmAsk.PreviousClosePrice = this.askPrevClose;
        }
        if (!isNaN(this.askMainClose)) {
            idbmAsk.TodayClosePrice = this.askMainClose;
        }
        if (this.askTicks !== 0) {
            idbmAsk.Ticks = this.askTicks;
        }
        if (!isNaN(this.askTotalvolume)) {
            idbmAsk.Volume = this.askTotalvolume;
        }
        // по бидам
        const idbmBid = new DirectInstrumentDayBarMessage();
        idbmBid.InstrumentBarType = HistoryType.QUOTE_LEVEL1;
        idbmBid.TradableId = tradableId;
        idbmBid.QuoteRouteId = routeId;
        idbmBid.cTime = now;
        idbmBid.TargetInstrumentName = i_id;
        if (!isNaN(this.bidOpen)) {
            idbmBid.Open = this.bidOpen;
        }
        if (!isNaN(this.bidHigh)) {
            idbmBid.High = this.bidHigh;
        }
        if (!isNaN(this.bidLow)) {
            idbmBid.Low = this.bidLow;
        }
        if (!isNaN(this.bidPrevClose)) {
            idbmBid.PreviousClosePrice = this.bidPrevClose;
        }
        if (!isNaN(this.bidMainClose)) {
            idbmBid.TodayClosePrice = this.bidMainClose;
        }
        if (this.bidTicks !== 0) {
            idbmBid.Ticks = this.bidTicks;
        }
        if (!isNaN(this.bidTotalvolume)) {
            idbmBid.Volume = this.bidTotalvolume;
        }
        let mainIDBM;
        if (this.instrument.HistoryType === HistoryType.QUOTE_TRADES) {
            mainIDBM = idbmTrade;
        }
        else if (this.instrument.HistoryType === HistoryType.QUOTE_ASK) {
            mainIDBM = idbmAsk;
        }
        else {
            mainIDBM = idbmBid;
        }
        mainIDBM.OpenInterest = this.openInterest;
        mainIDBM.SettlementPrice = this.settlementPrice;
        mainIDBM.PrevSettlementPrice = this.prevSettlementPrice;
        mainIDBM.FiftyTwoWeekHighPrice = this.FiftyTwoWeekHighPrice;
        mainIDBM.FiftyTwoWeekLowPrice = this.FiftyTwoWeekLowPrice;
        mainIDBM.High13Week = this.High13Week;
        mainIDBM.Low13Week = this.Low13Week;
        mainIDBM.High26Week = this.High26Week;
        mainIDBM.Low26Week = this.Low26Week;
        mainIDBM.ReferencePrice = this.ReferencePrice;
        return [idbmAsk, idbmBid, idbmTrade];
    }
}
